import { PlayerComponentCSSStyleImpl } from '../../../../toolkit/player/playercss';

export class BannerCardMobilePlayerCSSStyleImpl extends PlayerComponentCSSStyleImpl
{
    getPlayDivCSSStyle(): object 
    {
        return {
            // display: "flex",
            // textAlign: "center",
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // position: "absolute",
            // marginTop: "20px",
            top:'110px',
            right:'30px',
            // marginLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"0px":'30px',
            // marginRight: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?"30px":'0px',
            cursor: "pointer",
            width: "50px",
            height: "50px",
            position:'absolute'
        };
    }

    getPlayIconCSSStyle(): object 
    {
        return {
            cursor: "pointer",
            height: "50px",
            width: "50px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannercardmobileplayercss.tsx